import { inject } from '@angular/core';
import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BYPASS_API_ROUTING } from '../api-clients/api-routing.context';
import { SHARED_ENVIRONMENT } from '../environment/shared-environment.token';
import { resolveRewrittenUrl } from './api-url-resolver';

export function apiRoutingInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  // Issued through a TargetApiClient, so it already names its service. Rewriting here would
  // let the generated table override an explicit choice.
  if (req.context.get(BYPASS_API_ROUTING)) {
    return next(req);
  }

  const env = inject(SHARED_ENVIRONMENT);
  const rewrittenUrl = resolveRewrittenUrl(req.url, env);

  if (rewrittenUrl === req.url) {
    return next(req);
  }

  return next(req.clone({ url: rewrittenUrl }));
}
